module.exports = __webpack_public_path__ + "img/morning-woman.7d4cd539.jpg";